import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getSettingFormInputs } from "../model/settings.modal";
import { menuUrl } from "../setting-list/setting.list.constants";
import SettingEditTemplateComponent from "./setting.edit.template";
import { editSettingApi } from "./setting.edit.service";
import { PRIMARY_KEY } from "@constants/app.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  SETTINGS_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const SettingEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "edit");

  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSettingSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let settingPayload = {};
    for (let i = 0; i < values.length; i++) {
      settingPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const settingResponse = await editSettingApi(
      location?.state?.row[PRIMARY_KEY],
      settingPayload
    );

    // INFO : check api response and show relevant alert message
    if (settingResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: settingResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getSettingFormInputs({
      setting_name: location?.state?.row?.setting_name || "",
      setting_value: location?.state?.row?.setting_value || "",
      textAutocomplete: {
        name: "System",
        value: 2,
      },
      repeater: [
        { pollEvent: "11", date: "11" },
        { pollEvent: "22", date: "22" },
      ],
    }),
  };

  const templateEvents = {
    handleSettingSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <SettingEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default SettingEditComponent;
